{
	"exportsPer": "exports per",
	"mo": "/mo"
}
